import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { caseDellaVoce } from '../../utils/agenda';
import { linkChiama } from '../../utils/percorso';
import Icona from '../cliente/Icone';

// COSA fare, PER CHI e SU COSA, uguale in Oggi, Adesso della scheda cliente e agenda (voce.cosa, backend/agenda.py):
// [icona] "Richiamare Zetaci (Chiara, 02 1234567)" · per Serhii K. · Villa via Rosa del Sasso 8 · 2° tentativo ·
// perché: “chiedere disponibilità per sabato”. Il cliente apre la scheda cliente, l'immobile la sua card nella
// scheda Immobili (evidenziata), l'agenzia la scheda agenzia (solo admin), il telefono è un link tel:.

export const ICONE_TIPO = {
  visita: 'casa', telefonata: 'telefono', scadenza: 'orologio', rogito: 'chiave', documento: 'documento', compleanno: 'stella',
  nota: 'documento', altro: 'calendario', visita_richiesta: 'casa', documenti: 'documento',
};

export const linkCliente = (id) => `/admin/clienti/${id}`;
export const linkImmobileInScheda = (clienteId, immobileId) => (clienteId
  ? `/admin/clienti/${clienteId}?evidenzia=${encodeURIComponent(immobileId)}#immobili` : `/immobili/${immobileId}`);

const Agenzia = ({ agenzia, testo, conLink }) => (conLink && agenzia.id
  ? <Link to={`/admin/agenzie/${agenzia.id}`} title={agenzia.etichetta || undefined}>{testo}</Link>
  : <span title={agenzia.etichetta || undefined}>{testo}</span>);

// "Richiamare Zetaci": il nome dell'agenzia diventa il link, anche quando è già dentro la frase scritta a mano
const Azione = ({ azione, agenzia, conLink }) => {
  if (!agenzia?.nome) return azione;
  if (agenzia.nel_testo) {
    const nome = typeof agenzia.nel_testo === 'string' ? agenzia.nel_testo : agenzia.nome;  // il nome o la sua prima parola
    const i = azione.toLowerCase().indexOf(nome.toLowerCase());
    if (i < 0) return azione;
    return <>{azione.slice(0, i)}<Agenzia agenzia={agenzia} conLink={conLink} testo={azione.slice(i, i + nome.length)} />{azione.slice(i + nome.length)}</>;
  }
  return <>{azione} <Agenzia agenzia={agenzia} conLink={conLink} testo={agenzia.nome} /></>;
};

// voce: serve solo alla telefonata raggruppata (più case della stessa agenzia per lo stesso cliente): al posto
// dell'immobile singolo la frase dice "per 3 case di Serhii" e sotto c'è l'elenco degli indirizzi, uno per riga,
// ognuno con il link alla sua casa. Senza `voce` (o con una casa sola) la voce resta identica a prima.
const CosaVoce = ({ cosa, tipo, senzaCliente = false, voce = null }) => {
  const { userType } = useAuth();
  if (!cosa) return null;
  const { agenzia, cliente, immobile } = cosa;
  const persona = cosa.contatto;   // il contatto (non cliente) del prossimo passo; `contatto` qui sotto è il referente
  const case_ = caseDellaVoce(voce);
  const tel = linkChiama(agenzia?.telefono);
  const contatto = agenzia && (agenzia.referente || agenzia.telefono) ? (
    <> ({agenzia.referente}{agenzia.referente && agenzia.telefono ? ', ' : ''}
      {agenzia.telefono && (tel ? <a href={tel}>{agenzia.telefono}</a> : agenzia.telefono)})</>
  ) : null;
  const dove = [];
  if (case_.length) {
    dove.push(
      <React.Fragment key="case">
        per {case_.length} case{cliente && !senzaCliente ? <> di <Link to={linkCliente(cliente.id)}>{cliente.nome}</Link></> : null}
      </React.Fragment>,
    );
  } else {
    if (cliente && !senzaCliente) dove.push(<React.Fragment key="c">per <Link to={linkCliente(cliente.id)}>{cliente.nome}</Link></React.Fragment>);
    // il prossimo passo di un contatto: non è un cliente, ma il nome porta alla sua scheda lo stesso
    if (persona && !senzaCliente) dove.push(<React.Fragment key="ct">per <Link to={`/admin/contatti/${persona.id}`}>{persona.nome}</Link></React.Fragment>);
    if (immobile) dove.push(<Link key="i" to={linkImmobileInScheda(cliente?.id, immobile.id)}>{immobile.nome}</Link>);
  }
  if (cosa.tentativo) dove.push(<React.Fragment key="t">{cosa.tentativo}° tentativo</React.Fragment>);
  if (cosa.perche) dove.push(<React.Fragment key="p">perché: “{cosa.perche}”</React.Fragment>);
  const frase = (
    <p className="frase">
      <strong className="che"><Azione azione={cosa.azione} agenzia={agenzia} conLink={userType === 'admin'} />{contatto}</strong>
      {dove.map((pezzo, i) => <span className="dove" key={i}> · {pezzo}</span>)}
    </p>
  );
  return (
    <div className="cosa" data-testid="cosa">
      <span className={`ico k-${tipo}`} aria-hidden="true"><Icona nome={ICONE_TIPO[tipo] || 'calendario'} /></span>
      {case_.length === 0 ? frase : (
        // gli indirizzi sotto la frase, uno per riga: il div tiene l'elenco incolonnato con la frase
        <div style={{ minWidth: 0 }}>
          {frase}
          <ul className="cosa-case" data-testid="cosa-case">
            {case_.map((c) => (
              <li key={c.immobile_id}>
                <Link to={linkImmobileInScheda(cliente?.id, c.immobile_id)}>{c.indirizzo || 'casa senza indirizzo'}</Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CosaVoce;
